import { FormDefinition } from "../../Components/Form/Form";
import { FormGroupDefinition } from "../../Components/FormGroup";
import { address_validator, basic_number_validator, basic_text_validator, business_number_validator, date_validator, email_validator, multiselect_validator, phone_validator, postal_code_validator, selection_validator, url_validator } from "../formFieldValidators";

export const founderProgramDetailsFormDefinition: FormDefinition = {
  name: {
    label: "Service Name",
    frLabel: "Nom du service",
    inputType: "text",
    validator: basic_text_validator
  },
  description: {
    label: "Service Description",
    frLabel: "Description du service",
    inputType: "textarea",
    validator: basic_text_validator
  }
}

export const lockedContentFormDefition: FormDefinition = {
  content: {
    inputType: "htmlParser",
    label: "Enrolled Service Content",
    frLabel: "Contenu du service inscrit"
  }
}

export const addressFormDefinition: FormDefinition = {
  streetNumber: {
    label: "Street Number",
    frLabel: "Numéro civique",
    inputType: "text",
    validator: basic_text_validator,
  },
  streetName: {
    label: "Street Name",
    frLabel: "Nom de la rue",
    inputType: "text",
    validator: basic_text_validator,
  },
  unitNumber: {
    label: "Unit Number",
    frLabel: "Numéro d'appartement",
    tooltip: {
      content: "Optional Field"
    },
    frTooltip: {
      content: "Optionnel"
    },
    inputType: "text",
    validator: {
      ...basic_text_validator,
      required: false
    }
  },
  postalCode: {
    label: "Postal Code",
    frLabel: "Code postal",
    inputType: "text",
    placeholder: "A1A 1A1",
    frPlaceholder: "A1A 1A1",
    validator: postal_code_validator,
  },
  city: {
    label: "City",
    frLabel: "Ville",
    inputType: "text",
    validator: basic_text_validator,
  },
  province: {
    label: "Province",
    frLabel: "Province",
    inputType: "text",
    validator: basic_text_validator,
  },
  country: {
    label: "Country",
    frLabel: "Pays",
    inputType: "text",
    validator: basic_text_validator,
  }
};

export const founderProfileFormGroupDefinition: FormGroupDefinition = {
  /* Contact Information */
  personalInfo: {
    sectionLabel: "Personal Information",
    frSectionLabel: "Renseignements personnels",
    formDefinition: {
      firstName: {
        label: "First Name",
        inputType: "text",
        frLabel: "Prénom",
        validator: basic_text_validator,
      },
      lastName: {
        label: "Last Name",
        frLabel: "Nom de famille",
        inputType: "text",
        validator: basic_text_validator,
      },
      // [TODO] handle conditional checkboxes and other field feature
      pronouns: {
        label: "Your Pronouns",
        frLabel: "Vos pronoms",
        inputType: "customMultiSelectNarrow",
        validator: multiselect_validator,
        additionalData: {
          selectionData: [
            {
              text: "she/her",
              frText: "elle",
              value: "she"
            },
            {
              text: "he/him",
              frText: "il",
              value: "he"
            },
            {
              text: "they/them",
              frText: "eux",
              value: "they"
            },
            {
              text: "prefer not to say",
              frText: "préfère ne pas répondre",
              value: "notToSay"
            },
          ]
        }
      },
      title: {
        label: "Job Title",
        inputType: "text",
        frLabel: "Titre du poste",
        validator: basic_text_validator,
      },
      phoneNumber: {
        label: "Phone Number",
        inputType: "text",
        frLabel: "Numéro de téléphone",
        placeholder: "(123) 456-7890",
        frPlaceholder: "(123) 456-7890",
        validator: phone_validator,
      },
      isPointOfContact: {
        label: "I'm the point of contact",
        frLabel: "Je suis la personne ressource à contacter",
        inputType: "checkbox",
        tooltip: {
          content: "If you would prefer email notification and communication from EIP to go to another point of contact, please leave this checkbox unselected and specify the preffered point of contact below",
          position: "bottom-right"
        },
        frTooltip: {
          content: "Si vous préférez que les avis par courriel et les communications d'ÉPI soient envoyés à un autre point de contact, ne cochez pas cette case et indiquez le point de contact souhaité ci-dessous.",
          position: "bottom-right"
        },
      }
    }
  },
  pointOfContact: {
    conditionalRenderDefinition: {
      fieldKey: "isPointOfContact",
      renderWhenTrue: false,
    },
    sectionLabel: "Point of Contact",
    frSectionLabel: "Personne-ressource",
    formDefinition: {
      firstName: {
        label: "First Name",
        frLabel: "Prénom",
        inputType: "text",
        validator: basic_text_validator,
      },
      lastName: {
        label: "Last Name",
        frLabel: "Nom de famille",
        inputType: "text",
        validator: basic_text_validator,
      },
      // [TODO] pronouns is waiting on conditional checkboxes feature
      title: {
        label: "Job Title",
        frLabel: "Titre du poste",
        inputType: "text",
        validator: basic_text_validator,
      },
      email: {
        label: "Email",
        frLabel: "Courriel",
        inputType: "text",
        validator: email_validator,
      },
      phoneNumber: {
        label: "Phone Number",
        frLabel: "Numéro de téléphone",
        inputType: "text",
        placeholder: "(123) 456-7890",
        frPlaceholder: "(123) 456-7890",
        validator: phone_validator,
      },
      // [TODO] roleTags is waiting on conditional checkboxes feature
    }
  },
  /* Company Information */
  basicInfo: {
    sectionLabel: "Company Information",
    frSectionLabel: "Renseignements sur l'entreprise",
    formDefinition: {
      operatingName: {
        label: "Operating Name",
        frLabel: "Nom opérationnel",
        inputType: "text",
        validator: basic_text_validator,
      },
      // isLegalNameSameAsOperatingName: {
      //   label: "Our company's legal name is the same as its operating name.  Full legal name must be provided.",
      //   frLabel: "Le nom légal de notre société est le même que son nom opérationnel.  Le nom légal complet doit être fourni.",
      //   inputType: "checkbox",
      // },
      legalName: {
        // conditionalRenderDefinition: {
        //   fieldKey: "isLegalNameSameAsOperatingName",
        //   renderWhenTrue: false,
        // },
        label: "Legal Name",
        frLabel: "Nom légal",
        inputType: "text",
        validator: basic_text_validator,
      },
      description: {
        label: "Company Description",
        frLabel: "Description de l'entreprise",
        inputType: "textarea",
        validator: basic_text_validator,
      },
      industry: {
        label: "Industry",
        frLabel: "Industrie",
        inputType: "dropdownSelect",
        tooltip: {
          content: "Click on the field and select an option from the list.",
          position: "bottom-right"
        },
        frTooltip: {
          content: "Cliquer sur le champ et sélectionner une option de la liste.",
          position: "bottom-right"
        },
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "Agriculture",
              text: "Agriculture",
              frText: "Agriculture",
            },
            {
              value: "Advanced Materials & Manufacturing: Excludes specifically forestry, agriculture, mining, clean technologies and life sciences",
              text: "Advanced Materials & Manufacturing: Excludes specifically forestry, agriculture, mining, clean technologies and life sciences",
              frText: "Matériaux d'avant-garde et fabrication Exclut spécifiquement la sylviculture, l'agriculture, l'exploitation minière, les technologies propres et les sciences de la vie.",
            },
            {
              value: "Clean Tech: Technologies that protect and/or increase efficient utilization of land, water and air resources",
              text: "Clean Tech: Technologies that protect and/or increase efficient utilization of land, water and air resources",
              frText: "Tech. propres : technologies qui protègent et/ou augmentent l'utilisation efficace des ressources de la terre, de l'eau et de l'air",
            },
            {
              value: "Consumer Retail",
              text: "Consumer Retail",
              frText: "Consommation de détail",
            },
            {
              value: "Digital Media & Telecommunications: Digital applications and content and information and communications technologies. Excludes healthcare, agriculture, forestry, mining, financial services, education, social innovation, culture/recreation and energy-related solutions",
              text: "Digital Media & Telecommunications: Digital applications and content and information and communications technologies. Excludes healthcare, agriculture, forestry, mining, financial services, education, social innovation, culture/recreation and energy-related solutions",
              frText: "Médias numériques et télécommunications Applications numériques et technologies de l'information et de communication Exclut les soins de santé, l'agriculture, la sylviculture, l'exploitation minière, les services financiers, l'éducation, l'innovation sociale, la culture et loisirs, et les solutions liées à l'énergie.",
            },
            {
              value: "Education",
              text: "Education",
              frText: "Éducation",
            },
            {
              value: "Financial Services",
              text: "Financial Services",
              frText: "Services financiers",
            },
            {
              value: "Food & Beverage",
              text: "Food & Beverage",
              frText: "Restauration/production d'aliments et boissons",
            },
            {
              value: "Forestry",
              text: "Forestry",
              frText: "Foresterie",
            },
            {
              value: "Life Sciences & Health",
              text: "Life Sciences & Health",
              frText: "Sciences de la vie et de la santé",
            },
            {
              value: "Mining, Oil & Gas: Includes extractive activities that would not otherwise fall under clean technologies",
              text: "Mining, Oil & Gas: Includes extractive activities that would not otherwise fall under clean technologies",
              frText: "Exploitation minière, pétrole et gaz : Comprend les activités d'extraction qui ne relèveraient pas autrement des technologies propres",
            },
            {
              value: "Tourism & Culture: Includes entertainment and sports",
              text: "Tourism & Culture: Includes entertainment and sports",
              frText: "Culture et tourisme : comprend le divertissement et le sport",
            },
            {
              value: "Transportation",
              text: "Transportation",
              frText: "Transport",
            },
            {
              value: "Other",
              text: "Other",
              frText: "Autre",
            }
          ]
        }
      },
      websiteURL: {
        label: "Website URL",
        frLabel: "URL du site Web",
        inputType: "text",
        validator: url_validator,
      },
    }
  },
  registration: {
    sectionLabel: "Registration Information",
    frSectionLabel: "Enregistrement de l'entreprise",
    formDefinition: {
      number: {
        label: `The business number (BN), assigned to all incorporated businesses by the Canada Revenue Agency, is a 9-digit number that is unique to a business or legal entity. (Note: the BN is followed by a two-letter program identifier and a 4-digit reference number, both of which are unnecessary for this application). This number is different from the 7-digit Corporation Number and should not contain a hyphen.  If a valid 9-digit BN is not provided, the application will be rejected as it is a requirement for participation in ElevateIP.  For more details on what a BN is, visit (<a target='_blank' href='https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/you-need-a-business-number-a-program-account.html'>this website</a>)",`,
        frLabel:  `Le numéro d'entreprise (NE) est un numéro à 9 chiffres attribué à toutes les entreprises constituées en société par l'Agence du revenu du Canada. Détenir un numéro d'enregistrement est une condition pour participer à ÉleverlaPI. Pour plus d'informations sur les numéros d'entreprise, (<a target='_blank' href='https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/you-need-a-business-number-a-program-account.html'> cliquez ici.</a>)",`,
        inputType: "text",
        placeholder: "123456789",
        frPlaceholder: "123456789",
        validator: business_number_validator
      },
      date: {
        label: "Registration Date",
        inputType: "date",
        frLabel: "Date de l'enregistrement",
        validator: date_validator,
      },
      province: {
        label: "Registered Provinces and Territories",
        inputType: "multiSelectNarrow",
        frLabel: "Provinces et territoires enregistrés",
        validator: multiselect_validator,
        additionalData: {
          selectionData: [
            {
              value: "AB",
              text: "Alberta",
              frText: "Alberta"
            },
            {
              value: "BC",
              text: "British Columbia",
              frText: "Colombie-Britannique"
            },
            {
              value: "MB",
              text: "Manitoba",
              frText: "Manitoba"
            },
            {
              value: "NB",
              text: "New Brunswick",
              frText: "Nouveau-Brunswick"
            },
            {
              value: "NL",
              text: "Newfoundland and Labrador",
              frText: "Terre-Neuve-et-Labrador"
            },
            {
              value: "NT",
              text: "Northwest Territories",
              frText: "Territoires du Nord-Ouest"
            },
            {
              value: "NS",
              text: "Nova Scotia",
              frText: "Nouvelle-Écosse"
            },
            {
              value: "NU",
              text: "Nunavut",
              frText: "Nunavut"
            },
            {
              value: "ON",
              text: "Ontario",
              frText: "Ontario"
            },
            {
              value: "PE",
              text: "Prince Edward Island",
              frText: "Île-du-Prince-Édouard"
            },
            {
              value: "QC",
              text: "Quebec",
              frText: "Québec"
            },
            {
              value: "SK",
              text: "Saskatchewan",
              frText: "Saskatchewan"
            },
            {
              value: "YT",
              text: "Yukon",
              frText: "Yukon"
            },
          ]
        }
      }
    }
  },
  mailingAddress: {
    sectionLabel: "Mailing Address",
    frSectionLabel: "Adresse postale",
    formDefinition: addressFormDefinition,
  },
  programingEvaluation: {
    sectionLabel: "Service Evaluation",
    frSectionLabel: "Évaluation du service",
    formDefinition: {
      hasSocialOrEnvironmentalGoals: {
        frLabel: "Un des fondements et objectifs de votre entreprise est pour un bénéfice à la société ou à l'environnement?",
        label: "Does your company have social or environmental goals as part of its founding mission?",
        inputType: "boolean",
      },
      numFullTimeEmployees: {
        frLabel: "Nombre d'employés à temps plein (ETP)",
        label: "Number of Full Time Employees",
        inputType: "number",
        validator: basic_number_validator,
        tooltip: {
          content: "Companies with more than 500 full-time employees are not eligible for ElevateIP.",
          position: "bottom-right"
        },
        frTooltip: {
          content: "Les entreprises de plus de 500 employés à temps plein ne sont pas admissibles à ÉleverlaPI.",
          position: "bottom-right"
        },
      },
      isProductForSaleOnMarket: {
        frLabel: "Le produit que vous cherchez à sécuriser comme PI est-il actuellement en vente sur le marché?",
        label: "Is the product you are looking to protect currently for sale on the market?",
        inputType: "boolean"
      },
      productForSaleInfo: {
        conditionalRenderDefinition: {
          fieldKey: "isProductForSaleOnMarket",
          renderWhenTrue: true,
        },
        frLabel: "Veuillez sélectionner tous les énoncés qui s'appliquent",
        label: "Please select all that apply",
        inputType: "multiSelect",
        validator: multiselect_validator,
        additionalData: {
          selectionData: [
            {
              value: "singleProduct",
              text: "The product I want to protect is currently for sale",
              frText: "Le produit que je désire sécuriser comme PI est présentement en vente",
            },
            {
              value: "multipleProducts",
              text: "There are multiple products I want to protect that are currently for sale",
              frText: "Plusieurs produits que je désire sécuriser comme PI sont présentement en vente",
            },
          ]
        }
      },
      revenueOverTwelveMonths: {
        frLabel: "Indiquez le revenu total de votre entreprise (en CAD) au cours de votre dernier exercice financier.",
        label: "Indicate your company's total revenue (in $CAD) during your most recent fiscal year.",
        inputType: "number",
        validator: {
          ...basic_number_validator,
          min: {
            value: 0,
            message: "Revenue cannot be negative",
            frMessage: "Le revenu ne peut pas être négatif"
          }
        },
      },
      underrepresentedFounderGroups: {
        frLabel: "Nous nous engageons à accroître la diversité des personnes dans nos programmes et à faire en sorte que toutes les personnes vivent des expériences équitables et inclusives. Afin de suivre nos progrès vers cet objectif et de nous conformer aux exigences de financement du gouvernement fédéral, nous vous encourageons à indiquer si votre entreprise est détenue majoritairement par l'un des groupes sous-représentés suivants.",
        label: "Underrepresented Groups: A startup/BAI owned by an underrepresented group refers to those that are majority owned (50.1%) by an underrepresented group which includes: women, Indigenous Peoples (including First Nations, Métis and Inuit), 2SLGBTQI+, visible minorities, persons with disabilities or any community of people that experience significant collective barriers to participating in mainstream society.  We are committed to increasing the diversity of people in our programs and ensuring that all people have equitable and inclusive experiences throughout. In order to monitor our progress on this goal and to comply with Federal Government funding requirements, we are encouraging you to share whether your company is majority owned by any of the following underrepresented groups.  Please select all that apply:",
        inputType: "multiSelect",
        validator: multiselect_validator,
        additionalData: {
          selectionData: [
            {
              value: "women",
              text: "Women",
              frText: "Femmes"
            },
            {
              value: "indigenous",
              text: "Indigenous Peoples (including First Nations, Métis and Inuit)",
              frText: "Autochtones"
            },
            {
              value: "2slgbtqi+",
              text: "2SLGBTQI+",
              frText: "2SLGBTQI+"
            },
            {
              value: "visibleMinorities",
              text: "Visible Minorities",
              frText: "Minorités visibles"
            },
            {
              value: "disabilities",
              text: "Persons with Disabilities",
              frText: "Personnes handicapées"
            },
            // {
            //   value: "languageMinority",
            //   text: "Members of Official Language Minority Communities",
            //   frText: "Membres des communautés de langue officielle en situation minoritaire"
            // },
            {
              value: "other",
              text: "Any community of people that experience significant collective barriers to participating in mainstream society",
              frText: "Autre"
            },
            {
              value: "notToSay",
              text: "Prefer not to say",
              frText: "Préfère ne pas répondre"
            },
            {
              value: "none",
              text: "None of the Above",
              frText: "Aucune de ces réponses"
            }
          ],
          exclusiveValues: ["none"]
        }
      },
      isFromOLMC: {
        label: "Are you from an official language minority community (<a target='_blank' href='https://www.canada.ca/en/treasury-board-secretariat/services/values-ethics/official-languages/public-services/official-language-minority-communities.html'>OLMC</a>)?",
        frLabel:"Êtes-vous issu d'une communauté de langue officielle en situation minoritaire (CLOSM)?",
        inputType: "boolean",
      },
      officialLanguageMinorityCommunity: {
        conditionalRenderDefinition: {
          fieldKey: "isFromOLMC",
          renderWhenTrue: true,
        },
        label: "Which OLMC are you a part of?",
        frLabel: "De quelle CLOSM faites-vous partie?",
        inputType: "customDropdownSelect",
        // tooltip: {
        //   content:  "Click on the field and select an option from the list or Enter your own directly.",
        //   position: "top-left"
        // },
        // frTooltip: {
        //   content:  "Cliquer sur le champ et sélectionner une option de la liste ou saisissez votre propre classification directement.",
        //   position: "top-left"
        // },
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "ACF",
              frText: "Assemblée communautaire fransaskoise (ACF)",
              text: "Assemblée communautaire fransaskoise (ACF)",
            },
            {
              value: "AFO",
              frText: "Assemblée de la francophonie de l'Ontario (AFO)",
              text: "Assemblée de la francophonie de l'Ontario (AFO)",
            },
            {
              value: "FCFA",
              frText: "Fédération des communautés francophones et acadienne du Canada (FCFA)",
              text: "Fédération des communautés francophones et acadienne du Canada (FCFA)",
            },
            {
              value: "SFM",
              frText: "Société franco-manitobaine (SFM)",
              text: "Société franco-manitobaine (SFM)",
            },
            {
              value: "SNA",
              frText: "Société nationale de l'Acadie (SNA)",
              text: "Société nationale de l'Acadie (SNA)",
            },
          ]
        }
      },
      additionalLinks: {
        label: "Please Provide Any Additional Supporting Links (Pitch Deck, Business Plan, etc)",
        frLabel: "Veuillez fournir tout lien supplémentaire à l'appui (pitch deck, plan d'affaires, etc.)",
        inputType: "text",
        placeholder: "https://example.com",
        frPlaceholder: "https://exemple.com",
        validator: url_validator,
        tooltip: {
          content: "Enter a single URL linking to your pitch deck, business plan, or other supporting material.",
          position: "bottom-right"
        },
        frTooltip: {
          content: "Entrez une seule URL vers votre pitch deck, plan d'affaires ou autre document de soutien.",
          position: "bottom-right"
        },
      },
    }
  },
  iPStrategy: {
    sectionLabel: "IP Readiness",
    frSectionLabel: "Préparation à la PI",
    formDefinition: {
      seekingEducation: {
        frLabel: "Cherchez-vous à obtenir une formation générale en matière de propriété intellectuelle (par exemple, par où commencer? Qu'est-ce qu'un brevet?)",
        label: "Are you seeking general IP education (e.g. Where do I start? What is a patent?)",
        inputType: "boolean",
      },
      seekingSupport: {
        frLabel: "Cherchez-vous un soutien pour créer, améliorer ou réviser votre stratégie de propriété intellectuelle (par exemple, comment déterminer ce que je dois protéger? Qui peut m'aider à effectuer une recherche de brevetabilité ou de nouveauté?",
        label: "Are you seeking support to create, enhance or review your IP strategy (e.g. How do I determine what I'm protecting? Who can help with a patentability/novelty search?)",
        inputType: "boolean",
      },
      filePatentReady: {
        frLabel: "Vous serez prêt à déposer un brevet dans les 3 à 6 prochains mois?",
        label: "Are you ready to file patents in the next 3-6 months?",
        inputType: "boolean",
      },
      filePatentReadyYes: {
        conditionalRenderDefinition: {
          fieldKey: "filePatentReady",
          renderWhenTrue: true,
        },
        frLabel: "Veuillez indiquer lesquels des éléments ci-dessous s'appliquent dans votre cas",
        label: "Please indicate which of the following apply to you",
        inputType: "multiSelect",
        validator: multiselect_validator,
        additionalData: {
          selectionData: [
            {
              text: "I filed a provisional patent application in the last 12 months",
              value: "filedPatentApplication",
              frText: "J'ai déposé une demande de brevet provisoire au cours des 12 derniers mois"
            },
            {
              text: "In the past 12 months I filed a regular patent application that will serve as the priority filing for subsequent filings",
              value: "filedPriorityPatentApplication",
              frText: "Au cours des 12 derniers mois, j'ai déposé une demande de brevet régulière qui servira de dépôt prioritaire pour les dépôts ultérieurs."
            },
            {
              text: "I filed a PCT application in the past 30 months",
              value: "filedPCTApplication",
              frText: "J'ai déposé une demande PCT au cours des 30 derniers mois"
            },
            {
              text: "I am seeking support to help me convert a provisional application or a PCT, or to file a subsequent application using my priority application",
              value: "supportApplication",
              frText: "Je recherche de l'aide pour m'aider à convertir une demande provisoire ou un PCT, ou à déposer une demande ultérieure en utilisant ma demande prioritaire."
            },
            {
              text: "My IP service provider completed a patentability or novelty search on the innovation that is captured in my provisional, PCT or priority national filing",
              value: "serviceProviderSearchInFiling",
              frText: "Mon fournisseur de services de PI a effectué une recherche de brevetabilité ou de nouveauté sur l'innovation qui est capturée dans mon dépôt national provisoire, PCT ou prioritaire."
            },
            {
              text: "I have one or more innovation that aren't yet the subject of a patent, and that I am ready to patent in the next 3-6 months",
              value: "readyPatentApplication",
              frText: "J'ai une ou plusieurs innovations qui ne font pas encore l'objet d'un brevet, et que je suis prêt à breveter d'ici 3 à 6 mois"
            },
            {
              text: "My IP service provider completed a patentability or novelty search on (all of) the innovation(s) that aren't yet the subject of a patent",
              value: "serviceProviderSearch",
              frText: "on fournisseur de services de PI a effectué une recherche de brevetabilité ou de nouveauté sur (l'ensemble) de la ou des innovations qui ne font pas encore l'objet d'un brevet"
            }
          ]
        }
      },
      fileTrademarkReady: {
        frLabel: "Vous serez prêt à soumettre une marque de commerce dans les 3 à 6 prochains mois?",
        label: "Are you ready to register a trademark in the next 3-6 months?",
        inputType: "boolean",
      },
      clearanceSearch: {
        conditionalRenderDefinition: {
          fieldKey: "fileTrademarkReady",
          renderWhenTrue: true,
        },
        frLabel: "Votre fournisseur de services IP a-t-il effectué une recherche d'autorisation?",
        label: "Has your IP service provider completed a clearance search?",
        inputType: "boolean",
      },
      isWorkingWithLawFirm: {
        frLabel: "Votre entreprise est présentement en contact avec une firme d'avocats et de PI",
        label: "Is your company currently working with an IP / Law firm?",
        inputType: "boolean",
      },
      workingLawFirms: {
        conditionalRenderDefinition: {
          fieldKey: "isWorkingWithLawFirm",
          renderWhenTrue: true,
        },
        frLabel: "Veuillez indiquer le nom des firmes",
        label: "Please list the name of firms",
        inputType: "customList",
      },
      isWorkingWithBai: {
        frLabel: "Votre entreprise travaille-t-elle actuellement avec un autre IAA (Incubateur Accélérateur d'Affaires)?",
        label: "Is your company currently working with a different BAI?",
        inputType: "boolean",
      },
      otherBai: {
        conditionalRenderDefinition: {
          fieldKey: "isWorkingWithBai",
          renderWhenTrue: true,
        },
        frLabel: "Veuillez indiquer quelle organisation",
        label: "Please specify which organization",
        inputType: "text",
        validator: basic_text_validator
      }
    }
  }
}
